// @ts-ignore
import style from './style';
import * as Photometrics from '../../photometrics';

const { lensOptionsForFixture, lampOptionsForFixture } = Photometrics;

const Numeric = ({ beam, dispatch }) => {

	function handleInput (event) {
		const el = event.srcElement;
		switch (el.name) {
			case 'ySource':
			case 'lamp':
			case 'beamAngle':
				dispatch({ type: 'VALUE_CHANGE', property: { [el.name]: el.value } });
				break;
			case 'distance':
				dispatch({ type: 'DISTANCE_CHANGE', property: { distance: el.value } });
				break;
			default:
				// eslint-disable-next-line no-console
				console.info(`unhandled event`, event);
		}
	}

	// Define parameter table rows
	const rows = [
		{ title: 'Height', units: '', key: 'ySource', allowInput: true },
		{ title: 'Distance', units: '', key: 'distance', allowInput: true },
		{ title: 'Beam', units: '°', key: 'beamAngle', allowInput: true },
		{ title: 'Lamp', units: '', key: 'lamp', allowInput: true },
		{ title: 'Elevation', units: '°', key: 'elevationAngle', allowInput: false },
		{ title: 'Throw', units: '', key: 'beamThrow', allowInput: false },
		{ title: 'Width', units: '', key: 'poolWidth', allowInput: false },
		{ title: 'Illumination', units: '', key: 'illumination', allowInput: false }
	];

	function inputCell(key, value, units, beam) {
		let options = null;
		switch (key) {
			case 'beamAngle':
				options = lensOptionsForFixture(beam);
				break;
			case 'lamp':
				options = lampOptionsForFixture(beam);
				break;
			default:
				return (<td><input type="number" value={value} onInput={handleInput} name={key} />{units}</td>);
		}
		return (<td><select value={value} onChange={handleInput} name={key}>
			{options.map(a => (<option value={a.value}>{a.value === value ? a.label.split('=')[0].trim() : a.label}</option>))}
		</select></td>);
	}

	// A row's value cell, as static or input field
	function cell({ key, units, allowInput }) {
		const value = beam[key];
		return allowInput
			? inputCell(key, value, units, beam)
			// Just display the value for non-input cells
			: (<td class={style.calc}>{value.toLocaleString()}{units}</td>);
	}

	function tagEvent(event) {
		event.gridIgnoreClick = true;
	}

	// The page
	return (
		<div class={style.numericPage} onmousedown={tagEvent}>
			<table>
				{rows.map((row) => (
					<tr>
						<td>{row.title}</td>
						{cell(row)}
					</tr>
				))}
			</table>
		</div>
	);
};

export default Numeric;



// WEBPACK FOOTER //
// ./components/numeric/index.js